import React, { useContext } from "react";
import { useMediaQuery } from "react-responsive";
import { useLocation, useNavigate } from "react-router-dom";

import { Button } from "@examspark/common-ui";
import { IconAccountCircleLine } from "@examspark/common-ui/dist/components/icons";

import { useAppContext } from "../providers/AppContext";
import { LTIContext } from "../providers/LTIProvider";

const AccountButton = () => {
  const [state] = useAppContext();
  const location = useLocation();
  const lti = useContext(LTIContext);
  const navigate = useNavigate();

  const isPhone = useMediaQuery({ maxWidth: 768 });

  return (
    <Button
      data-cy="header-account"
      variant="outlined"
      title={"Account"}
      onClick={(e) => {
        if (e.altKey) {
          console.log("BonfireContext:", state);
          console.log("LTIContext:", lti);
          console.log("Workspace ID:", state.workspaceUser?.id);
          console.log("User ID:", state.user?.id);
          console.log("User Email:", state.user?.email);
          console.log("Location", JSON.stringify(location));
          return;
        }

        navigate("/account");
      }}
    >
      <IconAccountCircleLine width="16" />
      {!isPhone && <>{state.user?.firstName}</>}
    </Button>
  );
};

export default AccountButton;
